// extracted by mini-css-extract-plugin
export default {"root":"style_root__ukc+v","label":"style_label__9mXex"};